import { jsx as _jsx } from "react/jsx-runtime";
import { useSelector } from 'react-redux';
import styled from 'styled-components';
import UIAlert from 'UIComponents/alert/UIAlert';
import UILink from 'UIComponents/link/UILink';
import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import getUsageTracker from 'pricing-pages-lib/utils/getUsageTracker';
import { getSuiteLegalDisclaimerUrl } from 'pricing-pages-lib/utils/urls';
import { isHSFXEligibleSelector } from '../../selectors/PromotionSelectors';
const Bold = styled.b.withConfig({
  displayName: "CrmSuiteAlert__Bold",
  componentId: "sc-16r4r1r-0"
})(["font-size:16px;"]);

const CrmSuiteAlert = ({
  suiteProductLevel
}) => {
  const isHSFXEligible = useSelector(isHSFXEligibleSelector);

  if (isHSFXEligible || !suiteProductLevel) {
    return null;
  }

  return /*#__PURE__*/_jsx(UIAlert, {
    type: "info",
    className: "m-top-4",
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: `planBuilder.crmSuiteAlert.${suiteProductLevel}_jsx`,
      elements: {
        UILink,
        Bold
      },
      options: {
        link: getSuiteLegalDisclaimerUrl(),
        onClick: () => {
          getUsageTracker().track('externalLinkClick', {
            name: 'crm-suite-terms',
            url: getSuiteLegalDisclaimerUrl()
          });
        }
      }
    })
  });
};

export default CrmSuiteAlert;